<app-dialog
  [title]="title"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Create',
      isDisabled:
        !radioOption.value || selectedSkus.length === 0 || !selectedVendor.value,
        spin:spin
    }
  ]"
  (action)="dialogAction($event)"
  (close)="close()"
>
  <div class="mapping-popup">
    <div class="grid-header_search py-4">
      <div class="grid-header_search-icon">
        <i
          class="fal pointer"
          (click)="clearSearch()"
          [ngClass]="{
            'fa-search': !searchInput.value,
            'fa-times': searchInput.value
          }"
        ></i>
      </div>
      <input
        type="text"
        class="grid-header_input"
        placeholder="Search Sku's"
        [formControl]="searchInput"
      />
      <div class="d-flex align-items-center ms-auto">
        <label class="me-3 font_size_12">New Product ID:</label><mat-radio-group class="label_selection" [formControl]="radioOption">
          <div class="row">
              <div class="col-md-6">
                  <mat-radio-button value="ASIN">ASIN</mat-radio-button>
              </div>
              <div class="col-md-6">
                  <mat-radio-button value="SKU">SKU</mat-radio-button>
              </div>
          </div>
      </mat-radio-group>
        <!-- <app-radio-group-renderer [radioButtonOptions]="radioButtonOptions" [buttonFormControl]="radioOption"></app-radio-group-renderer> -->
      </div>
    </div>
    <div class="mapping-detail row">
      <div class="col-md-6 product-create-box">
        <label class="title font_size_14">Unmapped SKU's</label>
        <div class="mb-1 d-flex align-items-center">
          <app-select-all-button class="unmapped-btn" [(data)]="master_checked" (dataChange)="setSelectAll($event)"></app-select-all-button>
          <span class="selected-items ms-auto me-3"><em>{{selectedSkus.length}} items selected</em></span>
        </div>
        
      </div>

      <div class="col-md-6 product-create-box ps-1">
        <div class="d-flex align-items-center mb-2">
          <label class="title">Products to Create</label>
          <div class="input-container d-flex align-items-center ms-auto">
            <label class="input-container_label mb-0" for=""
              >Choose vendor</label
            >
            <select type="text" class="input-container_input" [formControl]="selectedVendor">
              <option value="null" class="mat-option-override" disabled selected>Select</option>
              <option [value]="item.vendorId" *ngFor="let item of data.vendorList">{{ item.name }}</option>
            </select>
            <!-- <app-dropdown-renderer [dropdownOptions]="data.vendorList" [dropdownFormControl]="selectedVendor"></app-dropdown-renderer> -->
          </div>
        </div>
        <div class="gray-header py-2 mb-2">
          <label>Product</label>
          <label class="ms-auto">Mapping Qty</label>
        </div>
        
      </div>
    </div>
    <div class="mapping-detail row">
      <div class="col-md-6">
        <div class="sku-list">
          <div class="custom-scrollv2">
            <div
              class="marketplace_header"
              *ngFor="let sku of addToShipmentSkus$ | async"
            >
              <div>
                <mat-checkbox
                  (change)="selectUnmappedSku($event, sku)"
                  [(ngModel)]="sku.checked"
                >
                </mat-checkbox>
              </div>
              <app-item-typeahead [name]="sku.title" [sku]="sku.sku" [asin]="sku.asin" [image]="sku.imageUrl"></app-item-typeahead>              
            </div>
          </div>
          </div>
          <div  class="loader" *ngIf="loading">
            <img  src="assets/images/nineyard-loading.gif" >
        </div> 
      </div>
      <div class="col-md-6 product-create-box">
        <div class="sku-list">
          <div class="product-list" *ngFor="let sku of selectedSkus">
            <div class="marketplace_header">
            <app-item-typeahead [name]="sku.title" [id]="radioOption.value === 'SKU' ? sku.sku : sku.asin" [image]="sku.imageUrl"></app-item-typeahead>
            </div>
            <div class="qty-input-box d-flex align-items-center">
              <span class="me-2">x</span>
              <input
                class="qty-input form-control form-control-sm"
                type="number"
                [min]="1"
                [(ngModel)]="sku.mapQty"
              />
            </div>
          </div>
          </div>
      </div>
    </div>
  </div>
</app-dialog>
